/**
 * Redux listener middleware for cross-cutting side effects.
 *
 * Use this for reactions to actions that shouldn't live inside a component or a
 * slice reducer — e.g. clearing the in-memory token and RTK Query cache on sign
 * out. Add listeners with `startAppListening({ actionCreator, effect })`.
 */
import { createListenerMiddleware, addListener } from '@reduxjs/toolkit';

import { baseApi } from '@services/baseApi';
import { signedOut } from '@security/auth/authSlice';
import { clearAccessToken } from '@security/auth/tokenStore';

export const listenerMiddleware = createListenerMiddleware();

export const startAppListening = listenerMiddleware.startListening;
export const addAppListener = addListener;

// On sign out: drop the in-memory token and reset all cached API data.
startAppListening({
  actionCreator: signedOut,
  effect: async (_action, api) => {
    clearAccessToken();
    api.dispatch(baseApi.util.resetApiState());
  },
});
